// extracted by mini-css-extract-plugin
export default {"smallIcon":"License_smallIcon__WWz5M","alignedSmallIcon":"License_alignedSmallIcon__CmwNT"};